import React from 'react';
import { FixedStickyContainerPortalComponent } from '~/_shared/components/fixedStickyContainer/fixedStickyContainerPortal.component';
import { LayeredPortalComponent } from '~/_shared/components/layeredPortal/layeredPortal.component';
import { UnreachableCaseException } from '~/_shared/exceptions/unreachableCaseException';
import {
  getTextInputHeight, InputSize,
} from '../inputs';
import { type DropdownOption } from './regularDropdown.component';

export const getDropdownNumericOptions = (min: number, max: number, step = 1): DropdownOption<number>[] => {
  const options: DropdownOption<number>[] = [];
  let i = min;

  while (i <= max) {
    options.push({
      value: i,
      name: i.toString(),
    });

    i += step;
  }

  return options;
};

export enum DropDownItemSize {
  Default = 'default',
  Large = 'large'
}

export const getRegularDropdownTriggerSize = getTextInputHeight;

export const getRegularDropdownItemSize = (inputSize: InputSize, itemSize: DropDownItemSize): number => {
  if (itemSize === DropDownItemSize.Large) {
    return getRegularDropdownTriggerSize(inputSize);
  }

  switch (inputSize) {
    case InputSize.Xs:
      return 22;
    case InputSize.Small:
      return 26;
    case InputSize.Medium:
      return 32;
    case InputSize.Large:
      return 40;
    default:
      return 32;
  }
};

export enum DropdownDomPlacement {
  Local = 'local',
  LayerPortal = 'layer-portal',
  /** @deprecated Contact VilémJ if you think you really need this */
  GlobalPortal = 'global-portal',
}

export const getContentWrapper = (domPlacement: DropdownDomPlacement) => {
  switch (domPlacement) {
    case DropdownDomPlacement.Local:
      return React.Fragment;
    case DropdownDomPlacement.LayerPortal:
      return LayeredPortalComponent;
    case DropdownDomPlacement.GlobalPortal:
      return FixedStickyContainerPortalComponent;
    default:
      throw new UnreachableCaseException(domPlacement, `Unknown dropdown placement: ${domPlacement}`);
  }
};
